export default "__VITE_ASSET__9d06ee08__"